import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ComponentsModule } from "./components";

import { NgxUiLoaderModule } from "ngx-ui-loader";
import { SuccessPopUpComponent } from './success-pop-up/success-pop-up.component';
import { TableModule } from "primeng/table";
import { OrderByPipe } from './pipes/order-by.pipe';
import { SortedPipe } from "./pipes/custom-pipe";
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';

@NgModule({
  imports: [
    CommonModule, 
    ComponentsModule,
    NgxUiLoaderModule, 
    TableModule,
    FormsModule,
    DropdownModule
  ],
  declarations: [
    SuccessPopUpComponent,
    OrderByPipe,
    SortedPipe
  ],
  exports: [TableModule,OrderByPipe,SortedPipe, SortedPipe, ComponentsModule],
})
export class SharedModule {}
